// This file also exists in the server constants. Only regex constants used in client code are here.
export const REGEX_WHITE_SPACE = /\s+/g; // REGEX: target whitespace
export const REGEX_NEWLINES = /[\r\n]+/g; // REGEX: target line breaks
export const REGEX_NON_WORD_CHARS = /([^\w-]|_)+/g; // REGEX: target non-word chars including underscore
export const REGEX_CC_EXPIRY = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/; // REGEX: credit card expiration date in format MM/DD
export const REGEX_NON_DIGITS = /\D/g; // REGEX: target non-digits
export const REGEX_AMAZON_PAY_V1_ID = /^[SP]01-/; // REGEX: target Amazon Pay v1 ID prefix
export const REGEX_NUMBERS_ONLY = /^[0-9]*$/; // REGEX: must be numbers only
export const REGEX_PROJECT_NAME = /[^a-zA-Z0-9_.!@#$%^&*()\-=`~,<>./?;:'"[\]{}\\| \s]/; // REGEX: No special characters allowed other than specified
